import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { actions as cmsActions } from '../../../reducers/cms.reducer';
import { assetIsImage, typeDict } from '../../../helpers/assets';
var AssetMetaData = function AssetMetaData(_ref) {
  var assetID = _ref._id,
    filename = _ref.filename,
    size = _ref.size,
    resolution = _ref.resolution,
    extension = _ref.extension,
    dateAdded = _ref.dateAdded,
    type = _ref.type;
  var dispatch = useDispatch();
  var bucket = useSelector(function (s) {
    return s.config.bucket;
  });
  var formatFileSize = function formatFileSize(bytes, decimalPoint) {
    if (bytes == 0) return '0 Bytes';
    var k = 1000,
      dm = decimalPoint || 2,
      sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
      i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  };
  useEffect(function () {
    if (assetIsImage[type] && (!resolution || !filename)) {
      var img = new window.Image();
      img.onload = function () {
        dispatch({
          type: cmsActions.assets,
          payload: {
            formData: {
              resolution: {
                w: this.width,
                h: this.height
              },
              assetID: assetID
            },
            route: 'set-resolution',
            method: 'post'
          }
        });
      };
      img.src = "".concat(bucket, "/").concat(filename);
    }
  }, [resolution, filename]);
  return /*#__PURE__*/React.createElement("div", {
    className: "asset-md"
  }, assetIsImage[type] && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("span", null, "Width:"), " ", resolution !== null && resolution !== void 0 && resolution.w ? "".concat(resolution.w, " px") : 'Undefined'), /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("span", null, "Height:"), " ", resolution !== null && resolution !== void 0 && resolution.h ? "".concat(resolution.h, " px") : 'Undefined')), /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("span", null, "File size:"), " ", formatFileSize(size)), /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("span", null, "File type:"), " ", extension), /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("span", null, "Date Uploaded:"), " ", moment(dateAdded).format('Do MMM, YYYY')), /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("span", null, "Type:"), " ", typeDict[type] || 'Undefined'), /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("span", null, "URL:"), " ", "".concat(bucket, "/").concat(filename)));
};
export default AssetMetaData;